const createLock = () => {
  const queue = []

  let locked = false

  const acquire = async () => {
    if (locked) {
      return new Promise((resolve) => queue.push(resolve))
    }

    locked = true
  }

  const release = () => {
    if (queue.length > 0) {
      const next = queue.shift()
      next()
    } else {
      locked = false
    }
  }

  return {
    acquire,
    release,
  }
}

export default createLock
